import React from 'react';
import styled, { css } from 'styled-components';

export interface TopControlsProps {
	settings: any;
	children?: React.ReactNode;
	isInlinePlayer?: boolean;
	isMobile?: boolean;
	queryParams?: any;
	className?: string;
	onMouseEnter?: (_e: React.MouseEvent) => void;
	onMouseLeave?: (_e: React.MouseEvent) => void;
}
interface ComponentProps {
	isMobile?: boolean;
	tabIndex?: number;
	story?: boolean;
	overlay?: boolean;
}
const SpanComponentWithProps: React.FC<ComponentProps> = (props) => <span tabIndex={props.tabIndex}>{props.children}</span>;

const TopControlsContainer = styled.div<ComponentProps>`
	margin: 0 auto;
	padding: ${({ story, overlay }) => (overlay ? "calc(20px - 0.2rem) 50px 0px 20px" : story ? '20px 20px 0px 20px' : '0 0')};
	border-radius: 0;
	color: #fff;
	top: 0;
	position: absolute;
	width: 100%;
`;

const TopControlsLeft = styled.div`
	margin-left: 12px;
	margin-top: 12px;
	float: left;
	display: flex;
	align-items: center;
	z-index: 202;
	position: absolute;
`;

const TopControlsLeftFirstRow = styled.div`
	color: #fff;
	display: flex;
	justify-content: space-between;
	align-items: center;
`;

const TopControlsPlaybackTitleWrapper = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	border-radius: 4px;
`;

const TopControlsPlaybackTitle = styled.div`
	margin: 0 10px 3px 10px;
`;

const TopControlsMediaTitle = styled(SpanComponentWithProps)`
	background-color: black;
	padding: 5px;
	border-radius: 4px;
	&:focus {
		outline: 1px dashed white;
	}
	font-size: ${({ isMobile }) => (isMobile ? '1rem' : '1.5rem')};
`;

const TopControlsAccountTitle = styled(SpanComponentWithProps)`
	background-color: black;
	padding: 5px;
	border-radius: 4px;
	&:focus {
		outline: 1px dashed white;
	}
	${({ isMobile }) =>
		isMobile &&
		css`
			font-size: 0.75rem;
		`}
`;

const TopControlsRight = styled.div`
	margin-right: 12px;
	margin-top: 12px;
	float: right;
	display: flex;
	align-items: center;
	z-index: 202;
	position: relative;
`;

const TopControlsShadow = styled.div`
	background: transparent linear-gradient(0deg, rgba(0, 0, 0, 0) 0%, #000 100%) 0% 0% no-repeat padding-box;
	opacity: 0.8;
	padding-top: 12%;
	position: absolute;
	top: 0;
	width: 100%;
`;

export {
	TopControlsContainer,
	TopControlsLeft,
	TopControlsLeftFirstRow,
	TopControlsPlaybackTitleWrapper,
	TopControlsPlaybackTitle,
	TopControlsMediaTitle,
	TopControlsAccountTitle,
	TopControlsRight,
	TopControlsShadow,
};
